import { render, staticRenderFns } from "./StorageData.vue?vue&type=template&id=48dc27c2&"
import script from "./StorageData.vue?vue&type=script&lang=js&"
export * from "./StorageData.vue?vue&type=script&lang=js&"
import style0 from "./StorageData.vue?vue&type=style&index=0&id=48dc27c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports